import * as React from "react";
import {
  Box,
  Grid,
  Typography,
  Link as MuiLink,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import Chemitek from "../images/chemitek-1.png";

export default function FooterModern() {
  return (
    <Box
      px={{ xs: 3, sm: 5 }}
      py={{ xs: 6, sm: 8 }}
      bgcolor="#658bc4ff"
      color="#154385"
      mt={4}
    >
      <Grid
        container
        spacing={4}
        alignItems="flex-start"
        justifyContent="space-between"
      >
        {/* ===== Колона 1: Меню ===== */}
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Меню
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1.5}
            alignItems={{ xs: "center", md: "flex-start" }}
            textAlign={{ xs: "center", md: "center" }}
          >
            <MuiLink
              component={Link}
              to="/agents"
              underline="hover"
              sx={{ color: "#fae105" }}
            >
              Препарати
            </MuiLink>
            <MuiLink
              component={Link}
              to="/inquiry"
              underline="hover"
              sx={{ color: "#fae105" }}
            >
              Заяви оферта
            </MuiLink>
            <MuiLink
              component={Link}
              to="/services"
              underline="hover"
              sx={{ color: "#fae105" }}
            >
              Услуги
            </MuiLink>
            <MuiLink
              component={Link}
              to="/contacts"
              underline="hover"
              sx={{ color: "#fae105" }}
            >
              Контакти
            </MuiLink>
          </Box>
        </Grid>

        {/* ===== Колона 2: Контакти и копирайт ===== */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            За контакти
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems={{ xs: "center", md: "flex-start" }}
            textAlign={{ xs: "center", md: "center" }}
            gap={1.5}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <MarkEmailReadIcon fontSize="small" />
              <MuiLink
                href="mailto:info@tcenergy.bg"
                underline="hover"
                sx={{ color: "#fae105" }}
              >
                info@tcenergy.bg
              </MuiLink>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <PhoneIphoneIcon fontSize="small" />
              <MuiLink
                href="tel:+359884955699"
                underline="hover"
                sx={{ color: "#fae105" }}
              >
                +359 884 955 699
              </MuiLink>
            </Box>
            <Typography mt={1} variant="body2">
              © 2025 Ти Си Енерджи EООД
            </Typography>
          </Box>
        </Grid>

        {/* ===== Колона 3: Лого и социални под него ===== */}
        <Grid item xs={12} sm={12} md={4}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={2}
          >
            {/* Лого на контрастен фон с subtle hover */}
            <Box
              sx={{
                borderRadius: 1,
                p: 0.5,
                display: "flex",
                alignItems: "center",
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              <img src={Chemitek} height="55px" width="auto" alt="chemitek" />
            </Box>

            {/* Социални икони под логото */}
            <Box display="flex" gap={1.5}>
              <IconButton
                href="https://www.facebook.com"
                target="_blank"
                sx={{ color: "#f2d35c", "&:hover": { color: "#ffffff" } }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://www.linkedin.com"
                target="_blank"
                sx={{ color: "#f2d35c", "&:hover": { color: "#ffffff" } }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                href="https://www.instagram.com"
                target="_blank"
                sx={{ color: "#f2d35c", "&:hover": { color: "#ffffff" } }}
              >
                <InstagramIcon />
              </IconButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
